@switch (cardVariant()) {
  @case ('first') {
    <div
      class="wrapper-first"
      app-card-variant-first
      [fileCard]="fileCard()"
      [imgSize]="imgSize()"
      [infoTooltip]="getInfoTooltip()"
      [isNeedPreview]="isNeedPreview()"
      [isAction]="isAction(fileCard().fileParams.id)"
      [isImage]="isImage(fileCard())"
      (handleBtnClick)="handleClick($event)"
    ></div>
  }
  @case ('second') {
    <div
      class="wrapper-second"
      app-card-variant-second
      [fileCard]="fileCard()"
      [imgSize]="imgSize()"
      [infoTooltip]="getInfoTooltip()"
      [isNeedPreview]="isNeedPreview()"
      [isAction]="isAction(fileCard().fileParams.id)"
      [isImage]="isImage(fileCard())"
      (handleBtnClick)="handleClick($event)"
    ></div>
  }
}
